// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Layout-module--sidebar--2V-_U","content":"Layout-module--content--284sx"};